import { render } from "./Add.vue?vue&type=template&id=43348d73&scoped=true&ts=true"
import script from "./Add.vue?vue&type=script&lang=ts"
export * from "./Add.vue?vue&type=script&lang=ts"

import "./Add.vue?vue&type=style&index=0&id=43348d73&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43348d73"]])

export default __exports__